const productImagesAlt = document.querySelectorAll('.product-image--alt__item');

const slideChangeFunc = index => {
  const productActiveImageAlt = document.querySelector('.product-image--alt__item.is-active');
  if (productActiveImageAlt) {
    productActiveImageAlt.classList.remove('is-active');
    if(productImagesAlt[index]) {
      productImagesAlt[index].classList.add('is-active');
    }
  }else{
    if(productImagesAlt[index]) {
      productImagesAlt[index].classList.add('is-active');
    }
  }
};

const productImageThumbSlider = new Swiper('.product-image--thumbnail__container', {
  spaceBetween: 4,
  slidesPerView: 7.5,
  freeMode: true,
  watchSlidesProgress: true,
  direction: 'horizontal',
  grabCursor: true,
  draggable: true,
  loop: false,
  breakpoints: {
    901: {
      direction: 'vertical',
      spaceBetween: 6,
    },
  },
});

const productImageSlider = new Swiper('.product-image__container', {
  loop: false,
  slidesPerView: 1,
  thumbs: {
    swiper: productImageThumbSlider,
  },
  navigation: {
    nextEl: '.product-image__next',
    prevEl: '.product-image__prev',
  },
  on: {
    slideChange: swiper => {
      slideChangeFunc(swiper.realIndex);
    },
  },
});

const productImageAltList = document.querySelector('.product-image--alt');
const productImageAltItem = Array.from(document.querySelectorAll('.product-image--alt li'));

let maxHeight = 0;
productImageAltItem.forEach(function (item) {
  maxHeight = Math.max(maxHeight, item.offsetHeight);
});

productImageAltList.style.height = maxHeight + 'px';
